import React from "react";
import styles from "./field-label.module.scss";

interface FieldLabelProps {
	label: string;
	required?: boolean;
	children: React.ReactNode;
}

const FieldLabel: React.FC<FieldLabelProps> = ({ label, required = false, children }) => {
	return (
		<div className={styles.wrapper}>
			<span className={styles.label}>
				{label}
				{required && <span className={styles.asterisk}>*</span>}
			</span>
			{children}
		</div>
	);
};

export default FieldLabel;
